export default "/assets/images/mamatobe-circle.png?9c105a3688655b61b39651a778726f7d";